import { Routes } from "@angular/router";
import { AuthGuard } from "@login-guards/auth.guard";


export const routes: Routes = [
    {
        path: 'platforms',
        loadComponent: () => import("@login-pages/platforms/platforms.component").then(m => m.PlatformsComponent),
        canActivate: [AuthGuard(true)]
    },
    {
        path: '',
        loadComponent: () => import("@login-pages/auth/auth.component").then(m => m.AuthComponent),
        canActivate: [AuthGuard(false)],
    },
    {
        path: ':company',
        loadComponent: () => import("@login-pages/auth/auth.component").then(m => m.AuthComponent),
        canActivate: [AuthGuard(false)],
    },
    {
        path: 'auth',
        loadComponent: () => import("@login-pages/auth/auth.component").then(m => m.AuthComponent),
        canActivate: [AuthGuard(false)],
    },
    {
        path: '**',
        redirectTo: '/',
    }
];
